// Generic SSPContext type, no app-specific properties
export type TSSPContext<T = Record<string, never>> = T;

export type TSSPChain<T = Record<string, never>> = (ctx: TSSPContext<T>) => Promise<TSSPContext<T>>;

export const composeAndRunSSPChain = <T = Record<string, never>>(sspChain: TSSPChain<T>[]) => {
  return async (ctx: TSSPContext<T>): Promise<TSSPContext<T>> => {
    const run = async (index: number, currentCtx: TSSPContext<T>): Promise<TSSPContext<T>> => {
      const { statusCode, redirectUrl } = currentCtx as any;
      if (index >= sspChain.length || (statusCode && statusCode >= 400) || redirectUrl) {
        return currentCtx;
      }

      try {
        const nextCtx = await sspChain[index](currentCtx);
        return run(index + 1, nextCtx);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[SSP Chain Error]', {
          message: (err as Error).message,
          stack: (err as Error).stack,
          context: currentCtx,
          sspChainIndex: index
        });

        throw new Error(`Error in SSP chain at index ${index}: ${(err as Error).message}`);
      }
    };

    return run(0, ctx);
  };
};
